module.exports = __webpack_public_path__ + "img/nashib.ff48ee20.png";